import axios from "axios";
import { eTlfItemType } from "../enums";
import { ITocSection } from "../hierarchy/ITocSection";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";
import { TitlesFootnotesReadDto } from "../tlfItem/TitlesFootnotesReadDto";

export interface TocItemUpdateDto {
  tocId: string;
  tocNumber?: string;
  tocLabel?: string;
  tlfType: eTlfItemType;
  order: number;
}

export interface updateTocItemParams {
  reportId: string;
  tocUpdateDetails: TocItemUpdateDto;
}

export interface HierarchyReportDto {
  id: string;
  name: string;
  parentTag: string;
  tocMajorVersion: number;
  tocMinorVersion: number;
  sections: ITocSection[];
  shells: TitlesFootnotesReadDto[];
}

export interface TocItemsUpdateProps {
  hierarchyId: string;
  items: TocItemUpdateDto[];
  deletedItemId?: string;
}

export type HierarchyReportDtoDataReturn = IAxiosReturn<HierarchyReportDto>;

/**
 * Updates TOC items in the hierarchy.
 *
 * @param backEndUrl - The backend API base URL for making HTTP requests
 * @param tocItemsUpdate - The TOC items update data to save
 * @param controller - Optional AbortController for cancelling the request
 * @returns A promise resolving to `HierarchyReportDtoDataReturn` with updated hierarchy report data.
 */
export const updateTocItems = async (
  backEndUrl: string,
  tocItemsUpdate: TocItemsUpdateProps,
  controller: AbortController,
): Promise<HierarchyReportDtoDataReturn> => {
  let url = `${backEndUrl}Reports/${tocItemsUpdate.hierarchyId}/UpdateTocItems`;
  /* istanbul ignore else */
  if (tocItemsUpdate.deletedItemId) url += `?deletedItemId=${tocItemsUpdate.deletedItemId}`;
  try {
    const response = await axios.put(url, tocItemsUpdate.items, { signal: controller.signal });
    return { success: true, data: response.data };
  } catch (error: unknown) {
    return processAxiosError("Create new Version failed", error);
  }
};
